import { first, last, maxby, meanby, minby } from '@quromedical/utils';

/**
 * Aggregate measurement over a set of ranges
 *
 * @param window timeframe for the results to be calculated in
 * @param points measurements at points in time
 * @returns the measurements and the scores that it has (start,end,max,min and mean)
 */
export const getAggregatedRanges = (windowSize, points) => getWindowPoints(windowSize, points).map(item => ({
  start: item.start,
  end: item.end,
  measurements: item.measurements,
  mean: Math.round(meanby(item.measurements, value => +value.value)),
  max: maxby(item.measurements, value => value.value),
  min: minby(item.measurements, value => value.value)
}));

const allInclusive = _ref => {
  let {
    start,
    end
  } = _ref;
  return measurement => measurement.ts >= start && measurement.ts <= end;
};
/**
 * Bucket points into groups based on a time window duration
 */


export const getWindowPoints = (windowSize, points) => {
  var _first, _last;

  const sortedPoints = points.sort((a, b) => a.ts - b.ts);
  const firstPoint = (_first = first(sortedPoints)) === null || _first === void 0 ? void 0 : _first.ts;
  const lastPoint = (_last = last(sortedPoints)) === null || _last === void 0 ? void 0 : _last.ts;

  if (!(firstPoint && lastPoint)) {
    return [];
  }

  const numberOfWindows = Math.ceil((lastPoint - firstPoint) / windowSize);
  const windows = new Array(numberOfWindows).fill(undefined).map((_, index) => {
    const start = firstPoint + index * windowSize;
    const end = start + windowSize;
    const measurements = sortedPoints.filter(allInclusive({
      start,
      end
    }));
    return {
      measurements,
      start,
      end
    };
  });
  return windows;
};
//# sourceMappingURL=aggregate.js.map